export default __webpack_public_path__ + "static/layout-example-dark-d451779fd8f3317b6c13f70882624d12.png";